import {
  TComponentValue,
} from '@/types/openapi-type';

const details: Record<TComponentValue<'AuditEnvelopStabilizationCombinationType'>, string> = {
  0: 'Pridať čas k ignorovaným fázam.',
  1: 'Buď čas, alebo fázy, čokoľvek skončí skôr.',
  2: 'Buď čas, alebo fázy, čokoľvek skončí ako posledné.',
};

export default {
  details,
};
